import { render, staticRenderFns } from "./ContractView.vue?vue&type=template&id=1c454036&scoped=true&"
import script from "./ContractView.vue?vue&type=script&async=true&lang=js&"
export * from "./ContractView.vue?vue&type=script&async=true&lang=js&"
import style0 from "./ContractView.vue?vue&type=style&index=0&id=1c454036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c454036",
  null
  
)

export default component.exports